/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */

import clsx from 'clsx'
import React, {useState, useEffect, useRef} from 'react'
import {addToCart, removeFromCart} from '../../../../redux/action/card'
import {useSelector, useDispatch} from 'react-redux'
import {getFunctions, httpsCallable} from 'firebase/functions'
import AddressAutocomplete from '../../../../app/modules/apps/payment-management/AutoComplete'
import {generatePopup} from '../../../../utils/popup'
import * as Yup from 'yup'
import {Field, Formik} from 'formik'
import {Button} from 'react-bootstrap'
import {FlexRow} from '../../../helpers/CssHelpers'
import {json} from 'stream/consumers'
import {loadStripe} from '@stripe/stripe-js'
import {Elements, CardElement, useStripe, useElements} from '@stripe/react-stripe-js'

// Initialize Stripe
const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
    'pk_test_51RjLTXPf7U0kOHcwMl8aHLyumyrTGjRKw6OKCT59JkYyLtrLECMiEq0R9icSCQJ5lQP390Yyk8VUfNiSRSivnXV5004V5IiAjj'
)

function MarkerPreviewModal(props: any) {
  const {markerPreviewSrc, setShowMarkerPreview} = props
  return (
    <div
      style={{
        zIndex: '10001',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        className='p-5'
        style={{
          width: '360px',
          backgroundColor: '#fff',
          borderRadius: '8px',
          boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.25)',
        }}
      >
        <img
          src={markerPreviewSrc.current}
          style={{maxWidth: '330px', maxHeight: '250px'}}
          alt=''
        />
        <div className={'w-100 gap-3' + FlexRow}>
          <Button className='mt-7' variant='secondary' onClick={() => setShowMarkerPreview(false)}>
            Close
          </Button>
        </div>
      </div>
    </div>
  )
}

interface CartTrayProps {
  isOpen: boolean
  onClose: () => void
}

declare const fbq: {
  (command: 'init', pixelId: string): void
  (command: 'track', event: string, parameters?: unknown): void
}

// Inner component that uses Stripe hooks
const CartTrayContent: React.FC<CartTrayProps> = ({isOpen, onClose}) => {
  const stripe = useStripe()
  const elements = useElements()
  const dispatch = useDispatch()
  const cartItems = useSelector((state: any) => state.Card?.UserCart) || []
  const [subtotalPrice, setSubtotalPrice] = useState(0)
  const [subscriptionPrice, setSubscriptionPrice] = useState(0)
  const addValid = false
  const [showCC, setShowCC] = useState<boolean>(false)
  const [loadingEstimate, setLoadingEstimate] = useState<boolean>(false)
  const [address, setAddress] = useState<any>(null)
  const [estimate, setEstimate] = useState<any>(null)
  const [activatedScenes, setActivatedScenes] = useState<any>(0)
  const [needsEstimate, setNeedsEstimate] = useState<boolean>(false)
  const [addressTouched, setAddressTouched] = useState<any>(false)
  const environment = process.env.REACT_APP_ENVIRONMENT
  const userdata = useSelector((state: any) => state.Auth?.authProfile?.userData)
  const currentYear = new Date().getFullYear() % 100
  const functions = getFunctions()
  const [paymentProcessing, setPaymentProcessing] = useState<boolean>(false)
  const Allcard = useSelector((state: any) => state.Card?.UserCard)
  const paymentSuccess = false
  const paymentFail = false
  const [showMarkerPreview, setShowMarkerPreview] = useState(false)
  const markerPreviewSrc = useRef('')
  // const [addValid, setAddValid] = useState<boolean>(false)
  // const [tax, setTax] = useState<number>(1)
  // const [shipping, setShipping] = useState<number>(0)
  // const [paymentProcessing, setPaymentProcessing] = useState<boolean>(false)
  // const [paymentSuccess, setPaymentSuccess] = useState<boolean>(false)
  // const [paymentFail, setPaymentFail] = useState<boolean>(false)

  const defaultValues = {
    firstName: userdata?.firstName?.trim ? userdata.firstName.trim() : userdata?.firstName || '',
    lastName: userdata?.lastName?.trim ? userdata.lastName.trim() : userdata?.lastName || '',
    email: userdata?.protected?.email,
  }

  const handleAddressSelect = (place: any) => {
    console.log('place', place)
    let address = {}
    let recipient = {}
    place?.address_components?.forEach((component) => {
      if (component.types.includes('postal_code')) {
        address['zip'] = component.long_name
      }

      if (component.types.includes('street_number')) {
        address['street'] = component.long_name
      }

      if (component.types.includes('route')) {
        address['route'] = component.long_name
      }

      if (component.types.includes('premise')) {
        address['premise'] = component.long_name
      }

      if (component.types.includes('locality')) {
        address['city'] = component.long_name
      }

      if (component.types.includes('administrative_area_level_1')) {
        address['state'] = component.short_name
      }
    })

    recipient['address1'] =
      address['street'] +
      (address['route'] && address['route'] !== '' ? ' ' + address['route'] : '')
    recipient['country_code'] = 'US'
    recipient['state_code'] = address['state']
    recipient['city'] = address['city']
    recipient['zip'] = address['zip']
    if ('premise' in address) {
      recipient['address2'] = address['premise']
    } else {
      recipient['address2'] = ''
    }
    setAddress(recipient)
  }

  useEffect(() => {
    const process = async (address) => {
      const processCart = httpsCallable(functions, 'processCart')
      let paymentPayload: any = {
        billingInfo: address,
      }

      console.log('userdata', userdata)

      const isAdminMode = localStorage.getItem('isAdminMode') === 'true'
      const activeAccountId = localStorage.getItem('activeAccountId')
      const activeAccountType = localStorage.getItem('activeAccountType')

      if ((isAdminMode || activeAccountType === 'b2b') && activeAccountId) {
        paymentPayload['ownerId'] = activeAccountId
      } else {
        const originalUserId = localStorage.getItem('originalUserId')
        paymentPayload['ownerId'] = originalUserId
      }

      setLoadingEstimate(true)
      const res: any = await processCart(paymentPayload)
      if (res.data?.error_message) {
        generatePopup('error', res.data.error_message)
      }
      console.log(res?.data)
      setEstimate(res?.data)
      setLoadingEstimate(false)
    }
    if (address) {
      process(address)
    }
  }, [address, cartItems])

  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
      .min(3, 'Minimum 3 symbols')
      .max(50, 'Maximum 50 symbols')
      .required('First Name is required'),
    lastName: Yup.string()
      .min(3, 'Minimum 3 symbols')
      .max(50, 'Maximum 50 symbols')
      .required('Last Name is required'),
  })

  const handleRemoveItem = (index: number) => {
    let cartItem = {...cartItems[index]}
    dispatch(removeFromCart(cartItem))
  }

  const handleChangeQuantity = (index: number, newQty: any) => {
    let cartItem = {...cartItems[index], quantity: parseInt(newQty)}
    dispatch(addToCart(cartItem))
  }

  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      const form = e.target.form
      const index = Array.prototype.indexOf.call(form, e.target)
      if (form.elements[index + 1]) {
        form.elements[index + 1].focus()
      }
    }
  }

  // Regex

  const handleNameRegex = (e, formik) => {
    const inputValue = e.target.value
    if (!inputValue.match(/^[A-Za-z][A-Za-z\s]*$/)) {
      e.target.value = inputValue.replace(/[^A-Za-z\s]/g, '')

      // Ensure the first character is a letter
      if (e.target.value && !e.target.value[0].match(/[A-Za-z]/)) {
        e.target.value = e.target.value.substring(1)
      }
    }
    formik.handleChange(e)
  }

  const submitOrder = async (values) => {
    console.log('values', values)
    const processCart = httpsCallable(functions, 'processCart')

    // Check if Stripe is loaded
    if (!stripe || !elements) {
      generatePopup('error', 'Payment system is not ready. Please try again.')
      return
    }

    try {
      setPaymentProcessing(true)

      // Create payment method using Stripe Elements
      const cardElement = elements.getElement(CardElement)
      if (!cardElement) {
        throw new Error('Card element not found')
      }

      const {error: stripeError, paymentMethod} = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
        billing_details: {
          name: `${values?.firstName} ${values?.lastName}`,
          email: userdata?.protected?.email,
        },
      })

      if (stripeError) {
        throw new Error(stripeError.message || 'Failed to process card details')
      }

      // Prepare payment payload with payment method ID instead of raw card data
      let paymentPayload = {
        billingInfo: address,
        paymentMethodId: paymentMethod.id,
        firstName: values?.firstName,
        lastName: values?.lastName,
      }

      console.log('userdata', userdata)

      const isAdminMode = localStorage.getItem('isAdminMode') === 'true'
      const activeAccountId = localStorage.getItem('activeAccountId')
      const activeAccountType = localStorage.getItem('activeAccountType')

      if (isAdminMode && activeAccountId && activeAccountType === 'b2b') {
        paymentPayload['ownerId'] = activeAccountId
      }

      const originalUserId = localStorage.getItem('originalUserId')
      const currentUserId = localStorage.getItem('userId')

      if (originalUserId !== currentUserId) {
        paymentPayload['ownerId'] = currentUserId
      }

      const res: any = await processCart(paymentPayload)
      if (!res.data.error) {
        const win = window as any
        //console.log('res', res)
        if ('fbq' in win) {
          if (res?.data?.subscription_processed) {
            win.fbq('track', 'StartTrial', {
              value: '0.00',
              currency: 'USD',
              predicted_ltv: '0.00',
            })
          }

          if (res?.data?.total > 0) {
            let itemIds: any = []
            res?.data?.items.forEach((item: any) => {
              itemIds.push(item?.variant_id.toString())
            })
            win.fbq('track', 'Purchase', {
              value: res?.data?.total,
              currency: 'USD', // Replace with your currency
              quantity: 1, // Replace with the quantity
              content_ids: itemIds, // Replace with the relevant product IDs
            })
          }
        }

        generatePopup('success', 'Your order was processed successfully!')
        onClose()
        window.location.href = '/orders'
      } else {
        console.log('error res: ', res)
        generatePopup('error', res.data.error_message)
      }
    } catch (error: any) {
      console.error('Payment error:', error)
      generatePopup('error', error.message || 'Payment failed. Please try again.')
    } finally {
      setPaymentProcessing(false)
    }
  }

  const handleFormSubmit = async (values: any, {resetForm}) => {
    console.log('submitting', values)
    submitOrder(values)
  }

  const handleFreeSubmit = () => {
    submitOrder({
      billingInfo: address,
      paymentMethodId: null, // No payment needed for free items
    })
  }

  useEffect(() => {
    let activated_cards = 0
    Allcard.forEach((card) => {
      if (card.protected?.isActive) {
        activated_cards++
      }
    })
    setActivatedScenes(activated_cards)
  }, [Allcard])

  useEffect(() => {
    console.log('cartItems', cartItems)

    let subprice = 0
    let scenes_to_activate = {}
    /*
    if (cartItems.length === 0) {
      onClose();
      return
    }
*/
    const isBeta = userdata?.protected?.isBeta
    const isAdmin = userdata?.protected?.isAdmin
    const subId = userdata?.protected?.subscription?.id

    // Get account switching state
    const isAdminMode = localStorage.getItem('isAdminMode') === 'true'
    const mimicId = localStorage.getItem('mimicId')

    // Determine if admin is viewing another account
    const isAdminViewing = Boolean(mimicId || isAdminMode)

    // Determine if user should have admin privileges
    // Either they are an admin of their own account, or they are an admin viewing another account
    const hasAdminPrivileges = isAdmin || isAdminViewing

    cartItems.forEach((item, index) => {
      if (item?.requires_activation) {
        if (item.scene_id in scenes_to_activate) {
          scenes_to_activate[item.scene_id].push(item.variant_id)
        } else {
          scenes_to_activate[item.scene_id] = [item.variant_id]
        }
      }
      if (item.price && item.quantity) {
        setNeedsEstimate(true)
      } else {
        setNeedsEstimate(false)
      }
    })

    console.log('scenes_to_activate', scenes_to_activate)

    //subscriptionPrice = Object.keys(scenes_to_activate).length * 19.99
    setSubscriptionPrice(subprice)
    let itemsubtotal = cartItems.reduce((sum, item) => sum + (item.price * item.quantity || 0), 0)
    setSubtotalPrice(itemsubtotal)
  }, [cartItems])

  useEffect(() => {
    console.log('changed markerPreviewSrc')
  }, [markerPreviewSrc])

  return (
    <>
      {showMarkerPreview && (
        <MarkerPreviewModal
          markerPreviewSrc={markerPreviewSrc}
          setShowMarkerPreview={setShowMarkerPreview}
        />
      )}

      <div
        style={{
          position: 'fixed',
          top: '-6px',
          right: 0,
          // 1) We always keep the tray in the DOM
          // 2) We animate via transform
          transform: isOpen ? 'translateY(0)' : 'translateY(-100%)',
          transition: 'transform 0.3s ease-in-out',
          backgroundColor: '#fff',
          zIndex: '10000',
          minWidth: '300px',
          height: '100%',
          boxShadow: '0 2px 6px rgba(0,0,0,0.25)',
          overflowY: 'auto',
        }}
      >
        {/* Header */}
        <div style={{position: 'relative', height: '100%'}}>
          <div style={{display: 'flex', justifyContent: 'space-between', padding: '1rem'}}>
            <h4 style={{margin: 0}}>Your Cart</h4>
            <button
              onClick={onClose}
              style={{
                border: 'none',
                background: 'transparent',
                fontSize: '15px',
                fontWeight: 'bold',
                padding: '0',
              }}
            >
              X
            </button>
          </div>
          <hr style={{margin: 0}} />

          {/* Cart Items */}
          {cartItems.length === 0 ? (
            <div style={{padding: '1rem'}}>No items in cart.</div>
          ) : (
            cartItems.map((item, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '0.5rem 1rem',
                }}
              >
                <img
                  src={item?.marker?.compiledImageUrl}
                  onClick={() => {
                    markerPreviewSrc.current = item?.marker?.compiledImageUrl ?? ''
                    setShowMarkerPreview(true)
                  }}
                  style={{maxWidth: '40px', maxHeight: '40px'}}
                  alt=''
                />
                <div>
                  <strong>{item.name}</strong>
                  <div style={{fontSize: '0.85rem', color: '#777'}}>
                    {item.size}
                    {!item.is_digital ? ` / ${item.color}` : ''}
                  </div>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                  <div style={{width: '40px'}}>
                    {item.price > 0 && (
                      <input
                        type='number'
                        min='1'
                        value={item.quantity}
                        style={{width: '100%'}}
                        onChange={(e) => handleChangeQuantity(index, e.target.value)}
                      />
                    )}
                  </div>
                  <span>${item.price.toFixed(2)}</span>
                  <button
                    onClick={() => handleRemoveItem(index)}
                    style={{
                      backgroundColor: 'transparent',
                      fontSize: '25px',
                      border: 'none',
                      color: 'red',
                      fontWeight: 'bold',
                    }}
                  >
                    &times;
                  </button>
                </div>
              </div>
            ))
          )}

          <hr />

          {/* Footer */}
          {cartItems.length > 0 && (
            <div style={{padding: '1rem', position: 'absolute', bottom: '15px', width: '100%'}}>
              <Formik
                initialValues={defaultValues}
                validationSchema={validationSchema}
                onSubmit={handleFormSubmit}
                enableReinitialize
              >
                {(formik) => {
                  return (
                    <>
                      {((!needsEstimate && subscriptionPrice) ||
                        (estimate?.total && !estimate?.error)) && (
                        <form
                          id='kt_modal_add_user_form'
                          className='form'
                          encType='multipart/form-data'
                          onSubmit={formik.handleSubmit}
                        >
                          <div className='w-100'>
                            <div className='bg-white rounded-md p-1'>
                              <div>
                                {!paymentSuccess && !paymentFail ? (
                                  <div>
                                    <div>
                                      <div className='row mb-3'>
                                        <div className='col-sm-6'>
                                          <div style={{width: '100%'}} className=''>
                                            <label
                                              className='required fw-bold fs-8'
                                              style={{position: 'relative', top: '5px'}}
                                            >
                                              First Name
                                            </label>
                                            <div>
                                              <Field
                                                placeholder='First name on card'
                                                type='text'
                                                name='firstName'
                                                className={clsx(
                                                  'form-control form-control-solid mb-3 mb-lg-0',
                                                  {
                                                    'is-invalid':
                                                      formik.touched.firstName &&
                                                      formik.errors.firstName,
                                                  },
                                                  {
                                                    'is-valid':
                                                      formik.touched.firstName &&
                                                      !formik.errors.firstName,
                                                  }
                                                )}
                                                autoComplete='off'
                                                disabled={formik.isSubmitting}
                                                onKeyDown={handleKeyDown}
                                                onChange={(e) => {
                                                  handleNameRegex(e, formik)
                                                }}
                                              />
                                              {formik.touched.firstName && formik.errors.firstName && (
                                                <div className='fv-plugins-message-container'>
                                                  <div className='fv-help-block'>
                                                    <span role='alert'>
                                                      {Array.isArray(formik.errors.firstName)
                                                        ? (
                                                            formik.errors.firstName as string[]
                                                          ).join(', ')
                                                        : (formik.errors.firstName as string)}
                                                    </span>
                                                  </div>
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                        <div className='col-sm-6'>
                                          <div style={{width: '100%'}} className=''>
                                            <label
                                              className='required fw-bold fs-8'
                                              style={{position: 'relative', top: '8px'}}
                                            >
                                              Last Name
                                            </label>
                                            <div>
                                              <Field
                                                placeholder='Last name on card'
                                                type='text'
                                                name='lastName'
                                                className={clsx(
                                                  'form-control form-control-solid mb-3 mb-lg-0',
                                                  {
                                                    'is-invalid':
                                                      formik.touched.lastName &&
                                                      formik.errors.lastName,
                                                  },
                                                  {
                                                    'is-valid':
                                                      formik.touched.lastName &&
                                                      !formik.errors.lastName,
                                                  }
                                                )}
                                                autoComplete='off'
                                                disabled={formik.isSubmitting}
                                                onKeyDown={handleKeyDown}
                                                onChange={(e) => {
                                                  handleNameRegex(e, formik)
                                                }}
                                              />
                                              {formik.touched.lastName && formik.errors.lastName && (
                                                <div className='fv-plugins-message-container'>
                                                  <div className='fv-help-block'>
                                                    <span role='alert'>
                                                      {Array.isArray(formik.errors.lastName)
                                                        ? (formik.errors.lastName as string[]).join(
                                                            ', '
                                                          )
                                                        : (formik.errors.lastName as string)}
                                                    </span>
                                                  </div>
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className='row'>
                                        <div className='col-sm-12'>
                                          <div style={{width: '100%'}}>
                                            <label
                                              className='required fw-bold fs-8'
                                              style={{position: 'relative', top: '5px'}}
                                            >
                                              Card Details
                                            </label>
                                            <div
                                              className='form-control form-control-solid mb-3 mb-lg-0 border'
                                              style={{padding: '12px'}}
                                            >
                                              <CardElement
                                                options={{
                                                  style: {
                                                    base: {
                                                      fontSize: '16px',
                                                      color: '#424770',
                                                      '::placeholder': {
                                                        color: '#aab7c4',
                                                      },
                                                    },
                                                  },
                                                }}
                                              />
                                            </div>
                                            <div className='text-muted' style={{fontSize: '12px'}}>
                                              <i className='bi bi-shield-check me-1'></i>
                                              Powered by Stripe - Your payment information is secure
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div style={{textAlign: 'center', width: '100%'}}>
                                    <h1 style={{fontSize: '30px'}}>
                                      {paymentSuccess
                                        ? 'Your Payment Was Successful'
                                        : paymentFail
                                        ? 'Your Payment Was Declined'
                                        : 'Processing Payment'}
                                    </h1>
                                    <img
                                      style={{width: '100%'}}
                                      alt=''
                                      src={
                                        paymentSuccess
                                          ? '/media/payment_success.gif'
                                          : paymentFail
                                          ? '/media/payment_fail.gif'
                                          : '/media/payment_processing.gif'
                                      }
                                    />
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </form>
                      )}
                      <>
                        {needsEstimate && (
                          <div className='row mb-2'>
                            <div className='col-12'>
                              {!showCC && (
                                <AddressAutocomplete
                                  onAddressSelect={handleAddressSelect}
                                  valid={addValid}
                                  dropdownPosition='top'
                                />
                              )}
                              {!addValid && addressTouched && !estimate && (
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    margin: '5px',
                                  }}
                                >
                                  <i
                                    className='fas fa-circle-exclamation'
                                    style={{color: 'red', fontSize: '15px', marginRight: '4px'}}
                                  ></i>
                                  Enter a shipping address to checkout.
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                        {subscriptionPrice > 0 && (
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              marginBottom: '0.5rem',
                            }}
                          >
                            <span>Subscription Price:</span>
                            <strong>${subscriptionPrice.toFixed(2)} Per Month</strong>
                          </div>
                        )}
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginBottom: '0.5rem',
                          }}
                        >
                          <span>Product SubTotal:</span>
                          <strong>${subtotalPrice.toFixed(2)}</strong>
                        </div>
                        {estimate && (
                          <div>
                            {estimate?.tax && (
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  marginBottom: '0.5rem',
                                }}
                              >
                                <span>Tax:</span>
                                <strong>${estimate?.tax.toFixed(2)}</strong>
                              </div>
                            )}
                            {estimate?.shipping && (
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  marginBottom: '0.5rem',
                                }}
                              >
                                <span>Shipping:</span>
                                <strong>${estimate?.shipping.toFixed(2)}</strong>
                              </div>
                            )}
                            {estimate?.total && (
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  marginBottom: '0.5rem',
                                }}
                              >
                                <span>Total:</span>
                                <strong>${(estimate?.total + subscriptionPrice).toFixed(2)}</strong>
                              </div>
                            )}
                          </div>
                        )}
                        {/*JSON.stringify(
                          {
                            subscriptionPrice: subscriptionPrice,
                            needsEstimate: needsEstimate,
                            estimateerror:estimate?.error,
                            estaimtetotal:estimate?.total,
                          }
                        )*/}
                        <Button
                          onClick={() => {
                            subscriptionPrice === 0 && !needsEstimate
                              ? handleFreeSubmit()
                              : formik.handleSubmit()
                          }}
                          disabled={
                            formik.isSubmitting ||
                            !formik.touched ||
                            paymentProcessing ||
                            loadingEstimate
                          }
                          data-kt-users-modal-action='submit'
                          style={{
                            width: '100%',
                            padding: '0.75rem',
                            backgroundColor: '#007bff',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                          }}
                        >
                          {loadingEstimate
                            ? 'Loading Estimate...'
                            : paymentProcessing
                            ? 'Processing...'
                            : 'Checkout'}
                        </Button>
                      </>
                    </>
                  )
                }}
              </Formik>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

// Main wrapper component that provides Stripe Elements context
const CartTray: React.FC<CartTrayProps> = ({isOpen, onClose}) => {
  return (
    <Elements stripe={stripePromise}>
      <CartTrayContent isOpen={isOpen} onClose={onClose} />
    </Elements>
  )
}

export default CartTray
